"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
var rsRouter = {
  path: '/rs',
  component: _layout.default,
  redirect: '/rs/merchant',
  name: 'RS',
  meta: {
    title: 'RS管理',
    icon: 'el-icon-office-building'
  },
  children: [{
    path: 'merchant',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rs/merchant/index'));
      });
    },
    name: 'RSMerchantList',
    meta: {
      title: '商户管理',
      icon: 'el-icon-s-custom'
    }
  }, {
    path: 'merchant/store',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rs/merchant/store/index'));
      });
    },
    name: 'RSStoreManagement',
    meta: {
      title: '店铺管理',
      icon: 'el-icon-s-shop'
    }
  }, {
    path: 'merchant/detail',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rs/merchant/detail'));
      });
    },
    name: 'RSMerchantDetail',
    meta: {
      title: '商户详情',
      icon: 'el-icon-document'
    },
    hidden: true
  }, {
    path: 'merchant/oneCardMerchant',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/rs/merchant/oneCardMerchant/index'));
      });
    },
    name: 'RSOneCardMerchant',
    meta: {
      title: '一卡通商品SKU管理',
      icon: 'el-icon-goods'
    }
  }]
};
var _default = exports.default = rsRouter;